import {connect} from 'react-redux'
import Content from '../components/Content.jsx'

// Map Redux state to component props
function mapStateToProps (state) {
  return {
    content: state && state.page && state.page.content !== undefined
      ? state.page.content : null
  }
}

// Connected Component
const ContentContainer = connect(
  mapStateToProps
)(Content)

export default ContentContainer
